/* src/app/workshop-scheduler/pages/scheduler/scheduler.component.scss */
.schedulerPage {
  position: fixed;
  top: 3.5rem;
  left: 4.5rem;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background: #eef1f4;
}
.schedBar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;
}
.schedHeading {
  margin: 0 0.4rem 0 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #006498;
  white-space: nowrap;
}
.barDate,
.barBtn {
  height: 30px;
  border: 1px solid #cbd5e1;
  background: white;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #334155;
}
.barBtn {
  padding: 0 0.7rem;
  white-space: nowrap;
  cursor: pointer;
}
.barBtn:hover:not(:disabled) {
  border-color: #f99420;
  background: #fff7ed;
}
.barBtn:disabled {
  opacity: 0.45;
  cursor: default;
}
.barBtn.on {
  background: #24333f;
  border-color: #24333f;
  color: white;
}
.barDate {
  padding: 0 0.4rem;
}
.schedNav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 auto;
}
.schedNav .navBtn {
  width: 30px;
  padding: 0;
}
.schedNav .schedTitle {
  min-width: 12rem;
  text-align: center;
  font-size: 0.9rem;
}
.seg {
  display: inline-flex;
  height: 30px;
}
.seg .segBtn {
  border: 1px solid #cbd5e1;
  border-left-width: 0;
  background: white;
  padding: 0 0.65rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
}
.seg .segBtn:first-child {
  border-left-width: 1px;
  border-radius: 6px 0 0 6px;
}
.seg .segBtn:last-child {
  border-radius: 0 6px 6px 0;
}
.seg .segBtn:hover:not(.on) {
  background: #f1f5f9;
}
.seg .segBtn.on {
  background: #006498;
  border-color: #006498;
  color: white;
}
.zoomCtl {
  display: inline-flex;
  height: 30px;
}
.zoomCtl .zoomBtn,
.zoomCtl .zoomNow {
  border: 1px solid #cbd5e1;
  background: white;
  color: #1e293b;
  cursor: pointer;
}
.zoomCtl .zoomBtn {
  width: 30px;
  font-size: 1.05rem;
  line-height: 1;
}
.zoomCtl .zoomBtn:first-child {
  border-radius: 6px 0 0 6px;
}
.zoomCtl .zoomBtn:last-child {
  border-radius: 0 6px 6px 0;
}
.zoomCtl .zoomBtn:disabled {
  color: #b9bcbe;
  background: #fafafa;
  cursor: default;
}
.zoomCtl .zoomNow {
  min-width: 3.2rem;
  border-left: 0;
  border-right: 0;
  font-size: 0.78rem;
  font-variant-numeric: tabular-nums;
}
.zoomCtl .zoomBtn:hover:not(:disabled),
.zoomCtl .zoomNow:hover {
  background: #f1f5f9;
}
.schedError {
  margin: 0.6rem 1rem 0;
}
.schedulerLayout {
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 0.75rem;
  padding: 0.75rem 1rem 1rem;
}
.queue {
  flex: 0 0 16rem;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 0.6rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  padding: 1rem;
  overflow-y: auto;
}
.panelTitle {
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
}
.keyTitle {
  margin-top: 0.75rem;
}
.panelHint {
  font-size: 0.75rem;
  color: #64748b;
}
.queueList {
  flex: 1;
  margin-top: 0.75rem;
  overflow-y: auto;
  min-height: 6rem;
}
.queueJob {
  border-left: 4px solid #006498;
  border-radius: 0.4rem;
  background: #f8fafc;
  padding: 0.45rem 0.6rem;
  margin-bottom: 0.4rem;
  cursor: grab;
  font-size: 0.8rem;
  -webkit-user-select: none;
  user-select: none;
  touch-action: none;
}
.queueJob:hover {
  background: #eef2f7;
}
.queueJob .queueReg {
  font-weight: 700;
}
.queueJob .queueMeta {
  color: #64748b;
  font-size: 0.72rem;
}
.queueJob .overdue {
  color: #b3261e;
  font-weight: 700;
}
.colourKey {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 0.75rem;
}
.colourKey li {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.2rem;
}
.colourKey .swatch {
  display: inline-block;
  width: 1.4rem;
  height: 0.8rem;
  border-radius: 0.2rem;
  font-size: 0.65rem;
  line-height: 0.8rem;
  text-align: center;
}
.colourKey .overText {
  color: #b3261e;
  font-weight: 700;
  border: 1px solid #e2e8f0;
}
.colourKey .offSwatch {
  background: rgba(100, 116, 139, 0.2);
}
.colourKey .outsideSwatch {
  border: 2px solid #b3261e;
}
.colourKey .hatched {
  background:
    repeating-linear-gradient(
      135deg,
      rgba(179, 38, 30, 0.18) 0 4px,
      transparent 4px 8px);
  border: 1px solid rgba(179, 38, 30, 0.3);
}
.board {
  flex: 1;
  min-width: 0;
  overflow: auto;
  position: relative;
  background: white;
  border-radius: 0.6rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  -webkit-user-select: none;
  user-select: none;
}
.boardHead {
  display: flex;
  position: sticky;
  top: 0;
  z-index: 5;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  height: 3rem;
}
.corner {
  position: sticky;
  left: 0;
  z-index: 6;
  flex: 0 0 var(--label-w);
  background: white;
  border-right: 1px solid #e2e8f0;
  padding: 0.4rem 0.6rem;
  font-weight: 700;
  font-size: 0.8rem;
  display: flex;
  align-items: flex-end;
}
.headTrack {
  position: relative;
  flex: 0 0 auto;
}
.dayHead {
  position: absolute;
  top: 0;
  bottom: 0;
  border-left: 1px solid #cbd5e1;
}
.dayHead .dayName {
  position: sticky;
  left: var(--label-w);
  display: inline-block;
  max-width: 100%;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 0.15rem 0.35rem;
  white-space: nowrap;
  overflow: hidden;
}
.dayHead .tick {
  position: absolute;
  bottom: 0.2rem;
  font-size: 0.65rem;
  color: #64748b;
  padding-left: 0.15rem;
  border-left: 1px solid #e2e8f0;
  white-space: nowrap;
}
.nowFlag {
  position: absolute;
  bottom: 0;
  transform: translateX(-50%);
  background: #7b3ff2;
  color: white;
  font-size: 0.6rem;
  padding: 0 0.25rem;
  border-radius: 0.2rem;
  z-index: 2;
}
.emptyBoard {
  margin: 1rem;
}
.lane {
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  height: 3.4rem;
}
.laneLabel {
  position: sticky;
  left: 0;
  z-index: 4;
  flex: 0 0 var(--label-w);
  background: white;
  border-right: 1px solid #e2e8f0;
  padding: 0.35rem 0.6rem;
  overflow: hidden;
}
.laneLabel .fitterName {
  font-weight: 700;
  font-size: 0.85rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.laneLabel .inactive {
  color: #94a3b8;
  font-weight: 400;
}
.laneLabel .fitterTotals {
  font-size: 0.7rem;
  color: #64748b;
}
.laneLabel .fitterTotals.busy {
  color: #b3261e;
  font-weight: 700;
}
.track {
  position: relative;
  flex: 0 0 auto;
  background-image:
    linear-gradient(
      to right,
      #cbd5e1 1px,
      transparent 1px),
    linear-gradient(
      to right,
      #f1f5f9 1px,
      transparent 1px);
  background-size: var(--day-w) 100%, var(--hour-w) 100%;
}
.offHours {
  position: absolute;
  top: 0;
  bottom: 0;
  background: rgba(100, 116, 139, 0.12);
  pointer-events: none;
}
.offHours.closedDay {
  background:
    repeating-linear-gradient(
      135deg,
      rgba(100, 116, 139, 0.16) 0 6px,
      transparent 6px 12px);
  color: #64748b;
  font-size: 0.7rem;
  padding: 0.15rem 0.3rem;
  overflow: hidden;
  white-space: nowrap;
}
.absence {
  position: absolute;
  top: 0;
  bottom: 0;
  background:
    repeating-linear-gradient(
      135deg,
      rgba(179, 38, 30, 0.12) 0 6px,
      transparent 6px 12px);
  color: #b3261e;
  font-size: 0.7rem;
  padding: 0.15rem 0.3rem;
  overflow: hidden;
  white-space: nowrap;
}
.block {
  position: absolute;
  top: 0.35rem;
  bottom: 0.35rem;
  border-radius: 0.35rem;
  color: white;
  font-size: 0.72rem;
  line-height: 1.1;
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: grab;
  touch-action: none;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.25);
  z-index: 1;
}
.block.isDragging {
  opacity: 0.35;
}
.block.menuOpen {
  box-shadow: 0 0 0 2px #f99420;
}
.block.outside {
  outline: 2px solid #b3261e;
  outline-offset: 1px;
}
.block.done {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
  cursor: pointer;
}
.block .blockText {
  flex: 1;
  padding: 0 0.35rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.block .blockText.over {
  color: #b3261e;
  font-weight: 700;
}
.block .grip {
  flex: 0 0 6px;
  align-self: stretch;
  cursor: ew-resize;
}
.block .grip:hover {
  background: rgba(255, 255, 255, 0.35);
}
.preview {
  position: absolute;
  top: 0.25rem;
  bottom: 0.25rem;
  border: 2px dashed #2e7d32;
  background: rgba(46, 125, 50, 0.12);
  border-radius: 0.35rem;
  pointer-events: none;
  z-index: 2;
}
.preview.blocked {
  border-color: #b3261e;
  background: rgba(179, 38, 30, 0.12);
}
.nowLine {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #7b3ff2;
  pointer-events: none;
  z-index: 3;
}
.ghost {
  position: fixed;
  z-index: 1000;
  pointer-events: none;
  background: white;
  border: 1px solid #e2e8f0;
  border-left: 4px solid #2e7d32;
  border-radius: 0.4rem;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.2);
  padding: 0.4rem 0.6rem;
  font-size: 0.75rem;
  max-width: 18rem;
}
.ghost.blocked {
  border-left-color: #b3261e;
}
.ghost .ghostLabel {
  font-weight: 700;
}
.ghost .ghostReason {
  color: #b3261e;
}
.menuBackdrop {
  position: fixed;
  inset: 0;
  z-index: 999;
}
.blockMenu {
  position: fixed;
  z-index: 1000;
  width: 14rem;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.2);
  padding: 0.5rem;
  font-size: 0.8rem;
}
.blockMenu .menuHead {
  padding: 0.2rem 0.3rem 0.4rem;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 0.3rem;
}
.blockMenu .menuItem {
  display: block;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 0.35rem 0.4rem;
  border-radius: 0.3rem;
}
.blockMenu .menuItem:hover {
  background: #f1f5f9;
}
.blockMenu .menuItem.danger {
  color: #b3261e;
}
.blockMenu .menuDone {
  color: #2e7d32;
  padding: 0.3rem 0.4rem;
}
.blockMenu label {
  margin: 0.3rem 0 0.1rem;
  font-weight: 600;
}
.blockMenu .remainingInputs {
  display: flex;
  gap: 0.3rem;
}
.blockMenu .menuButtons {
  display: flex;
  gap: 0.3rem;
  margin-top: 0.5rem;
}
.toastMessage {
  position: fixed;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1001;
  background: #1e293b;
  color: white;
  padding: 0.6rem 1rem;
  border-radius: 0.4rem;
  font-size: 0.85rem;
  max-width: 36rem;
}
/*# sourceMappingURL=scheduler.component.css.map */
